import {
  faCircleCheck,
  faFlag,
  faMagnifyingGlass
} from "@fortawesome/free-solid-svg-icons";
import { isDefinedString, reduce } from "et3-type-guards";

import i18n from "../../constants/i18n";
import ET3Circle from "../../core/et3-circle";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Image from "../../core/et3-Image";
import Et3Text from "../../core/et3-text";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getDashBoardStore from "../../stores/dashboard-store";
import {
  WELCOME_APPROVE_BADGE,
  WELCOME_AVATAR_SIZE,
  WELCOME_BLOCK_GAP,
  WELCOME_BODY_PADDING_CSS,
  WELCOME_CARDS_GAP,
  WELCOME_CASES_BADGE,
  WELCOME_GREETING_FONT_SIZE,
  WELCOME_HEADER_GAP,
  WELCOME_MAX_WIDTH_CSS,
  WELCOME_META_FONT_SIZE,
  WELCOME_REPORTS_BADGE,
  WELCOME_ROLE_BACKGROUND,
  WELCOME_ROLE_FONT_SIZE,
  WELCOME_ROLE_HEIGHT,
  WELCOME_ROLE_LETTER_SPACING,
  WELCOME_ROLE_PADDING_X,
  WELCOME_ROLE_RADIUS,
  WELCOME_SECTION_FONT_SIZE,
  WELCOME_SECTION_LETTER_SPACING,
  WELCOME_SUBTITLE_FONT_SIZE,
  WELCOME_TEXT_GAP
} from "./welcome-constants";
import WelcomeQueueCard from "./WelcomeQueueCard";

const APPROVE_REJECT_PATH = "/approveReject";
const REPORTS_PATH = "/reports";
const INVESTIGATION_PATH = "/investigationCases";

const Welcome = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const user = getCorePersonalStore().user.get();
  const fullName = reduce(() => user.fullName, "");
  const role = reduce(() => user.role, "");
  const lastLogin = reduce(() => user.lastLogin, "");
  const userImageName = getCorePersonalStore().userPofilePic.get();
  const approvalCount = getDashBoardStore().approvalCount.get();
  const reportsCount = getDashBoardStore().reportsCount.get();
  const investigationCasesCount =
    getDashBoardStore().investigationCasesCount.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection={"column"}
      color={colors.all.transparent}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        maxWidth: WELCOME_MAX_WIDTH_CSS,
        padding: WELCOME_BODY_PADDING_CSS,
        gap: WELCOME_BLOCK_GAP * unitY
      }}
      alignItems="flex-start"
      justifyContent="flex-start"
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{
          width: "100%",
          minWidth: 0,
          gap: WELCOME_HEADER_GAP * unitX
        }}
        alignItems="center"
        justifyContent="flex-start"
        onClick={() => {}}
      >
        <ET3Circle
          withShadow={false}
          size={WELCOME_AVATAR_SIZE}
          color={colors.all.transparent}
          style={{
            borderRadius: WELCOME_AVATAR_SIZE * unitX,
            flexShrink: 0
          }}
          onClick={() => {}}
        >
          <Et3Image
            type="LOCAL"
            alt={i18n.get("ALKHATTABA_ADMIN")}
            imageName={userImageName}
            size={WELCOME_AVATAR_SIZE}
            onClick={() => {}}
            style={{}}
          />
        </ET3Circle>
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={0}
          height={0}
          fDirection={"column"}
          color={colors.all.transparent}
          style={{
            flexGrow: 1,
            minWidth: 0,
            gap: WELCOME_TEXT_GAP * unitY
          }}
          alignItems="flex-start"
          justifyContent="center"
          onClick={() => {}}
        >
          <ET3Div
            isScrollable={false}
            isExtendable={true}
            withShadow={false}
            width={0}
            height={0}
            fDirection={"row"}
            color={colors.all.transparent}
            style={{
              width: "100%",
              minWidth: 0,
              gap: WELCOME_HEADER_GAP * unitX
            }}
            alignItems="center"
            justifyContent="flex-start"
            onClick={() => {}}
          >
            <Et3Text
              fontFamily={"BOLD"}
              fontSize={WELCOME_GREETING_FONT_SIZE}
              text={`${i18n.get("WELCOME")} ${fullName}`}
              isSpan={false}
              color={colors.all.maastrichtBlue}
              style={{ margin: 0, textAlign: "left" }}
            />
            {!isDefinedString(role) ? null : (
              <ET3Div
                isScrollable={false}
                isExtendable={false}
                withShadow={false}
                width={0}
                height={WELCOME_ROLE_HEIGHT}
                fDirection={"row"}
                color={WELCOME_ROLE_BACKGROUND}
                style={{
                  boxSizing: "border-box",
                  width: "auto",
                  minWidth: 0,
                  flexShrink: 0,
                  height: WELCOME_ROLE_HEIGHT * unitY,
                  borderRadius: WELCOME_ROLE_RADIUS * unitX,
                  paddingLeft: WELCOME_ROLE_PADDING_X * unitX,
                  paddingRight: WELCOME_ROLE_PADDING_X * unitX
                }}
                alignItems="center"
                justifyContent="center"
                onClick={() => {}}
              >
                <Et3Text
                  fontFamily={"BOLD"}
                  fontSize={WELCOME_ROLE_FONT_SIZE}
                  text={role}
                  isSpan={false}
                  color={colors.all.bondiBlue}
                  style={{
                    margin: 0,
                    whiteSpace: "nowrap",
                    letterSpacing: WELCOME_ROLE_LETTER_SPACING * unitX
                  }}
                />
              </ET3Div>
            )}
          </ET3Div>
          <Et3Text
            fontFamily={"LIGHT"}
            fontSize={WELCOME_SUBTITLE_FONT_SIZE}
            text={i18n.get("WELCOME_SUBTITLE")}
            isSpan={false}
            color={colors.all.davysGrey}
            style={{ margin: 0, textAlign: "left" }}
          />
          {!isDefinedString(lastLogin) ? null : (
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={WELCOME_META_FONT_SIZE}
              text={`${i18n.get("LAST_LOGIN_AT")} ${lastLogin}`}
              isSpan={false}
              color={colors.all.dimGray}
              style={{ margin: 0, textAlign: "left" }}
            />
          )}
        </ET3Div>
      </ET3Div>
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={WELCOME_SECTION_FONT_SIZE}
        text={i18n.get("YOUR_QUEUES")}
        isSpan={false}
        color={colors.all.davysGrey}
        style={{
          margin: 0,
          textAlign: "left",
          letterSpacing: WELCOME_SECTION_LETTER_SPACING * unitX
        }}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{
          width: "100%",
          minWidth: 0,
          flexWrap: "wrap",
          gap: WELCOME_CARDS_GAP * unitX
        }}
        alignItems="flex-start"
        justifyContent="flex-start"
        onClick={() => {}}
      >
        <WelcomeQueueCard
          icon={faCircleCheck}
          accent={colors.all.bondiBlue}
          badgeBackground={WELCOME_APPROVE_BADGE}
          label={i18n.get("APPROVE_REJECT_DATA")}
          count={approvalCount}
          link={APPROVE_REJECT_PATH}
        />
        <WelcomeQueueCard
          icon={faFlag}
          accent={colors.all.darkOrange}
          badgeBackground={WELCOME_REPORTS_BADGE}
          label={i18n.get("REPORTS")}
          count={reportsCount}
          link={REPORTS_PATH}
        />
        <WelcomeQueueCard
          icon={faMagnifyingGlass}
          accent={colors.all.purple}
          badgeBackground={WELCOME_CASES_BADGE}
          label={i18n.get("INVESTIGATION_CASES")}
          count={investigationCasesCount}
          link={INVESTIGATION_PATH}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default Welcome;
